module.exports = __webpack_public_path__ + "media/assets/social-yt-4acd0e9ce53490221e9d5d720a2f33ef.png";